import { useRouter } from "vue-router";

export default function getPreviousRoute() {
  let router = useRouter();

  if (!history?.state?.back) return null;

  return router.resolve(history.state.back, history.state.current);
}
